import { Validator, errorMessages } from 'services/validator'
import { FIRST_NAME, LAST_NAME, EMAIL, PHONE_NUMBER } from '../constants'
import { EMAIL_EMPTY_MESSAGE, PHONE_NUMBER_EMPTY_MESSAGE } from './constants'
import { TERMS_AGREEMENT_PROPERTY, TERMS_AGREEMENT_UNSELECTED } from 'components/Login/CreateAccount/CreateAccountFormPage/constants'

export default Validator.combineValidators({
  [FIRST_NAME]: [
    {
      validators: Validator.required(),
      errorMessage: errorMessages.FIRST_NAME_EMPTY
    }, {
      validators: Validator.firstName(),
      errorMessage: errorMessages.FIRST_NAME_ERROR_MESSAGE
    }
  ],
  [LAST_NAME]: [
    {
      validators: Validator.required(),
      errorMessage: errorMessages.LAST_NAME_EMPTY
    }, {
      validators: Validator.lastName(),
      errorMessage: errorMessages.LAST_NAME_ERROR_MESSAGE
    }
  ],
  [PHONE_NUMBER]: [
    {
      validators: Validator.required(),
      errorMessage: PHONE_NUMBER_EMPTY_MESSAGE
    },
    {
      validators: Validator.primaryPhone(),
      errorMessage: errorMessages.PRIMARY_PHONE_NUMBER_INVALID
    }
  ],
  [EMAIL]: [
    {
      validators: Validator.required(),
      errorMessage: EMAIL_EMPTY_MESSAGE
    },
    {
      validators: Validator.email(),
      errorMessage: errorMessages.EMAIL_ERROR_MESSAGE
    }
  ],
  [TERMS_AGREEMENT_PROPERTY]: [
    {
      validators: Validator.required(),
      errorMessage: TERMS_AGREEMENT_UNSELECTED
    }
  ]
})
